import gql from 'graphql-tag';

export const EditorStopHeartbeatMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation EditorStopHeartbeatMutation(
			$contentId: ID!
			$contentType: String!
			$heartbeatUserType: ExperimentalHeartbeatUserType
		) @experimental {
			experimentalEditorStopHeartbeat(
				contentId: $contentId
				contentType: $contentType
				heartbeatUserType: $heartbeatUserType
			)
		}
	`;
